import { atom } from 'jotai';
import { $SEOCurrentTraffic } from 'shared/atoms';
import { EPageType, IArticleCurrentTraffic, IVideoCurrentTraffic } from 'shared/models';
import { Unreachable } from '@lemon8/web-app-shared/util';

export const $CurrentArticleId = atom((get) => {
  const traffic = get($SEOCurrentTraffic);
  const { pageType } = traffic;

  if (![EPageType.article, EPageType.video].includes(pageType)) {
    return Unreachable(`unexpected pageType: ${pageType}`);
  }

  const articleTraffic = traffic as IArticleCurrentTraffic | IVideoCurrentTraffic;

  return articleTraffic.groupId;
});
